type Values = Record<string, unknown>;
export const createToggle = (dict: { [key: string]: any }, handler: (v: Values) => void) => (
  values: Values,
) => {
  const keys = Object.keys(values);
  const hasAllValues = keys.every((valueKey) => values[valueKey] === dict[valueKey]);

  if (hasAllValues) {
    const nullifiedValues = keys.reduce((prev, curr) => ({ ...prev, [curr]: null }), {});
    handler(nullifiedValues);
  } else {
    handler(values);
  }
};
